import { AfterContentChecked, Directive, ElementRef, Input, OnChanges, Renderer2, SecurityContext, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import mixinDisabled from '../../mixins/disabled';
import { phxWebStyleTokens } from '../../styles/phx-tokens';

const DEFAULT_ICON_COLOR: string = phxWebStyleTokens.colorContentSubdued;
const DEFAULT_ICON_SIZE = 20;

const baseIconMixin = mixinDisabled(class {});

@Directive({
  selector: '[phx-icon]',
  host: {
    class: 'phx-icon',
    '[class.disabled]': 'disabled',
    '[style.display]': '"inline-block"',
    '[style.line-height]': '0',
  },
  inputs: ['disabled'],
})
export class PhxIconDirective extends baseIconMixin implements OnChanges, AfterContentChecked {
  /**
   * @deprecated Use `phxIcon` instead.
   */
  @Input() phxType: string;
  @Input() phxIcon: string;
  @Input() color: string = DEFAULT_ICON_COLOR;
  @Input() size: number = DEFAULT_ICON_SIZE;
  public icon$: Observable<string | SafeHtml>;

  constructor(private elementRef: ElementRef, private renderer: Renderer2, private sanitizer: DomSanitizer) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { phxIcon, disabled, color, size } = changes;

    if (phxIcon || disabled || color || size) {
      this.setIcon();
    }
  }

  ngAfterContentChecked(): void {
    if (!this.phxType) {
      this.iterateSVGs();
    }
  }

  get hostElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  setIcon(): void {
    if (this.phxType) {
      this.renderer.setProperty(this.hostElement, 'innerHTML', 'phxType is deprecated please use phxIcon');
    }
    this.renderer.setProperty(
      this.hostElement,
      'innerHTML',
      this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(this.phxIcon))
    );
    this.iterateSVGs();
  }

  public iterateSVGs(): void {
    const { children } = this.hostElement;
    let { length } = children;

    if (!length) {
      return;
    }

    while (length--) {
      const child = children[length];
      if (child.tagName.toLowerCase() === 'svg') {
        this.normalizeSVGElement(child as SVGElement);
      }
    }
  }

  public normalizeSVGElement(svg: SVGElement): void {
    this.recursivelyRemoveFillAttribute(svg);

    this.renderer.setAttribute(svg, 'fill', this.disabled ? 'currentColor' : this.color);

    if (this.phxType) {
      this.renderer.setAttribute(svg, 'data-icon-type', this.phxType);
    }

    if (!svg.hasAttribute('viewBox')) {
      this.renderer.setAttribute(svg, 'viewBox', '0 0 20 20');
    }

    this.renderer.setAttribute(svg, 'width', `${this.size}px`);
    this.renderer.setAttribute(svg, 'height', `${this.size}px`);
  }

  private recursivelyRemoveFillAttribute(element: Element): void {
    this.renderer.removeAttribute(element, 'fill');

    for (let i = 0; i < element.children.length; i++) {
      this.recursivelyRemoveFillAttribute(element.children[i]);
    }
  }
}
